module.exports = __webpack_public_path__ + "static/media/2_step 1.ba1d650e.PNG";